import { render } from "./addlist.vue?vue&type=template&id=fb335370"
import script from "./addlist.vue?vue&type=script&lang=js"
export * from "./addlist.vue?vue&type=script&lang=js"

import "./addlist.vue?vue&type=style&index=0&id=fb335370&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__